module.exports = "<ng-transclude ng-class=\"[$ctrl.classes, {'row justify-content-end no-gutters': !$ctrl.classes}]\"></ng-transclude>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/footer-bar/footer-bar.html
// module id = 1881
// module chunks = 0